/**
 * Lizard 悬浮购买按钮 - JavaScript
 * 桌面端 hover / 聚焦自动弹出下拉；移动端点击按钮切换下拉
 */

(function() {
  'use strict';

  function setOpen(hover, open) {
    if (!hover) return;
    hover.classList.toggle('is-open', open);
    var btn = hover.querySelector('[data-floating-trigger]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initFloatingButton() {
    // 产品页激活悬浮按钮点击（恢复 pointer-events）
    var wrappers = document.querySelectorAll('.lizard-floating-buy-wrapper');
    wrappers.forEach(function(wrapper) {
      wrapper.style.pointerEvents = 'auto';
    });

    // 点击触发按钮：移动端切换下拉显示（桌面端 hover 已处理）
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-floating-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var hover = trigger.closest('.lizard-floating-buy-hover');
      if (hover) setOpen(hover, !hover.classList.contains('is-open'));
    });

    // 点击平台链接后关闭下拉
    document.addEventListener('click', function(e) {
      var item = e.target.closest('.lizard-floating-item');
      if (!item) return;
      var hover = item.closest('.lizard-floating-buy-hover');
      if (hover) setOpen(hover, false);
    });

    // 点击关闭按钮收起下拉
    document.addEventListener('click', function(e) {
      var closer = e.target.closest('[data-floating-close]');
      if (!closer) return;
      e.preventDefault();
      var hover = closer.closest('.lizard-floating-buy-hover');
      if (hover) setOpen(hover, false);
    });

    // 点击其他区域关闭下拉
    document.addEventListener('click', function(e) {
      if (e.target.closest('.lizard-floating-buy-hover')) return;
      document.querySelectorAll('.lizard-floating-buy-hover.is-open').forEach(function(h) {
        setOpen(h, false);
      });
    });

    // ESC 关闭
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        document.querySelectorAll('.lizard-floating-buy-hover.is-open').forEach(function(h) {
          setOpen(h, false);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingButton);
  } else {
    initFloatingButton();
  }
})();
